/* src/app/features/honra/consulta-ipoc/abas/consulta-bacen/aba-consulta-bacen.component.scss */
/*# sourceMappingURL=aba-consulta-bacen.component.css.map */
